import SlimSelect from "slim-select";

$(function() {
    // ajax params
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        $searchMembersInput = $('.js-search-members-input'),
        $searchMembersSelect = $('.js-search-members-select'),
        $searchMembersBtn = $('.js-search-members-btn'),
        $searchMembersResult = $('.js-search-members-result'),
        $leadershipCarouselViewBtn = $('.js-leadership-carousel-view-btn'),
        paramObj = {
            action: 'load_member',
            postType: 'team',
            url: myajax,
            name: '',
            sector: '',
            location: '',
            service: ''
        };

    // Ajax helper functions
    function loadMembers(paramObj) {
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',
            success(data) {
                $searchMembersResult.html(data);
            }
        });
    }

    $searchMembersInput.on('keyup', function H(e) {
        let value = e.target.value;
        if (value) {
            paramObj.name = value;
        } else {
            paramObj.name = '';
        }
        $searchMembersBtn.removeAttr('disabled');
    });

    $searchMembersSelect.on('change', function H(e) {
        let $this = $(this),
            $thisArea = $this.attr('data-area'),
            $thisVal = $this.val();
        e.preventDefault();
        switch ($thisArea) {
            case 'sector':
                paramObj.sector = $thisVal;
                break;
            case 'location':
                paramObj.location = $thisVal;
                break;
            case 'service':
                paramObj.service = $thisVal;
                break;
            default:
                return;
        }
        $searchMembersBtn.removeAttr('disabled');
    });

    $searchMembersBtn.on('click', function H(e) {
        e.preventDefault();
        loadMembers(paramObj);
        console.log(paramObj);
    });

    $leadershipCarouselViewBtn.on('click', function H() {
        let curLocID = this.dataset.currentLocationId;
        sessionStorage.setItem('currentLocationId', `${curLocID}`);
    });

    $(window).on('load', function () {
        let curLocID = sessionStorage.getItem('currentLocationId'),
            $selectLoc = $('.js-search-members-location-select');
        if ($selectLoc.length) {
            var $searchMembersLocationSelect = new SlimSelect({
                select: '.js-search-members-location-select',
                showSearch: false
            });
            if (curLocID) {
                $searchMembersLocationSelect.setSelected(curLocID);
                paramObj.location = curLocID;
                loadMembers(paramObj);
            }
        }
        sessionStorage.clear();
    });
});